/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
// Libraries
import EventData from './EventData';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

// Styles
import './viewAuditTrails.scss';

const ViewAuditTrails = props => {
    const { data } = props;

    return (
        <form className="audit-trail-view-edit">
            <div className="form-section viewOnly">
                <div className="form-field">
                    <p className="label">Date &amp; Time</p>
                    <p className="label-value">{data.dateAndTime || '-'}</p>
                </div>
                <div className="form-field">
                    <p className="label">Event</p>
                    <p className="label-value">{data.event || '-'}</p>
                </div>
                <div className="form-field">
                    <p className="label">IP Address</p>
                    <p className="label-value">
                        {data.externalIpAddress || '-'}
                    </p>
                </div>
            </div>
            <div className="form-section viewOnly border-b">
                <div className="form-field">
                    <p className="label">Resources</p>
                    <p className="label-value">{data.resource || '-'}</p>
                </div>
                <div className="form-field">
                    <p className="label">User ID</p>
                    <p className="label-value">{data.userId || '-'}</p>
                </div>
                <div className="form-field status-section">
                    <p className="label">Status</p>
                    {data.status ? (
                        <div className={`status ${data.status}`}>
                            {data.status}
                        </div>
                    ) : (
                        <div>-</div>
                    )}
                </div>
            </div>

            {data.eventData && data.eventData.length ? (
                <EventData data={data.eventData} />
            ) : null}
        </form>
    );
};

const mapStateToProps = ({ auth, paymentLinkData, form }) => ({
    auth,
    paymentLinkData,
    formData: form['view-audit-trail'],
});

const mapDispatchToProps = dispatch => ({});

ViewAuditTrails.propTypes = {
    handleSubmit: PropTypes.func,
    closePopup: PropTypes.func,
    actionType: PropTypes.string,
    data: PropTypes.object,
    actions: PropTypes.func,
    formData: PropTypes.object,
    fetchData: PropTypes.object,
    resetPage: PropTypes.func,
};

export default compose(
    reduxForm({
        form: 'view-audit-trail',
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(ViewAuditTrails);
